import React, { useState } from 'react'
import { Button } from '../../components/ui/button'
import { toast } from 'react-toastify'
import axios from './../../axios'
import ConfirmationPopUp from './ConfirmationPopUp'

function AttendancePop({ setIsPopUpOpen, selectedStatus, formatDate, setIsConfirmPopUp, isConfirmPopUp, setInputValue }) {


    return (
        <div className=" successful_create_transprant_body ">
            <div className=" p-2 successful_create_container shadow" style={{ minHeight: "30vh" }}>
                <span className=" my-2 successfully_create_message">
                    <label htmlFor="reason" className='mr-2'> Reason:</label>
                    <textarea rows={2} cols={2} className='form-control' style={{ width: '375px' }} onChange={(e) => setInputValue(e.target.value)} />
                </span>
                <Button variant="ghost" className="bg-[#F77F00] text-white hover:bg-[#e76f00] py-4 mt-4" onClick={() => setIsConfirmPopUp(true)}>
                    Submit Attendance
                </Button>
                <img
                    style={{ position: "absolute", top: "30%", right: "26%" }}
                    src="/images/cross.svg"
                    className="btn-light p-2 rounded-circle"
                    alt=""
                    onClick={(e) => setIsPopUpOpen(false)}
                />
            </div>
            {isConfirmPopUp && <ConfirmationPopUp setIsConfirmPopUp={setIsConfirmPopUp} />}
        </div>
    )
}

export default AttendancePop